import {ChartInterface} from "../../store/declarations";

export const isNoNeedToSync = (syncCharts: ChartInterface[]) => !syncCharts.length || syncCharts.length === 0;

export const setSyncDate = (charts: ChartInterface[], lastSyncDate: number) => {
    for (const chart of charts) {
        chart.last_sync_date = lastSyncDate;
    }
};
